import component from './src/search-input.vue';
export default {
  install(Vue){
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/search-input/index.js